module.exports = __webpack_public_path__ + "img/itomanman_comic16.495c09e2.jpg";